(function() {
  document.addEventListener('click', function(e) {
    var item = e.target.closest('.video-bubbles__item');
    if (item) {
      e.preventDefault();
      e.stopPropagation();
      var url = item.getAttribute('data-video-url');
      var section = item.closest('[id^="video-testimonials-"]');
      var modal = section.querySelector('.video-modal');
      var player = section.querySelector('.video-modal__player');
      var placeholder = section.querySelector('.video-modal__placeholder');

      if (url && url.length > 0) {
        player.src = url;
        player.style.display = 'block';
        if (placeholder) placeholder.style.display = 'none';
        player.play().catch(function() {});
      } else {
        player.style.display = 'none';
        if (placeholder) placeholder.style.display = 'flex';
      }

      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      return;
    }

    if (e.target.classList.contains('video-modal__backdrop')) {
      closeVideoModal();
    }

    if (e.target.closest('.video-modal__close')) {
      closeVideoModal();
    }
  });

  function closeVideoModal() {
    var modals = document.querySelectorAll('.video-modal[aria-hidden="false"]');
    modals.forEach(function(modal) {
      var player = modal.querySelector('.video-modal__player');
      if (player) { player.pause(); player.src = ''; }
      modal.setAttribute('aria-hidden', 'true');
    });
    document.body.style.overflow = '';
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeVideoModal();
  });
})();
